import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="HRM">
                <h1>Integrated HRM Software Development Services</h1>
              </div>
              <div className=" banner_content_txt listing_flex">
                <p>
                  Build a custom HRM solution for your business and skyrocket
                  your teams’ workflows. Manage performance and productivity
                  through HRM{" "}
                  <Link to="/custom-software-development">
                    software development services.
                  </Link>
                </p>
                <ul>
                  <li>All-in-one management window</li>
                  <li>Team performance tracking</li>
                  <li>Workflow acceleration</li>
                  <li>Learning & development promotion</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
